module.exports = __webpack_public_path__ + "img/logo.22914e2e.png";